import find from 'lib/sequence/component/children/find'
import { hide, show } from 'lib/sequence/component/state/hidden'
import { curry, type PlatformEvent } from 'lib/util'

/**
 * Displays `resultsList` and hides `recentsLabel` and `recentsList` if the `event`'s detail
 * contains a defined `term` property. If `term` is undefined, does the oposite.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const toggleItemsLists = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
): void => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { resultsList, recentsLabel, recentsList } = find(actionComponent)
  const term = event?.detail?.term

  if (term) {
    hide(recentsLabel)
    hide(recentsList)
    show(resultsList)
  } else {
    show(recentsLabel)
    show(recentsList)
    hide(resultsList)
  }
}

export default curry(toggleItemsLists)
